export class EntrepriseSearch {
  constructor (rechercheEntreprise) {
    this.siret = rechercheEntreprise ? rechercheEntreprise.siret : null
    this.raisonSociale = rechercheEntreprise ? rechercheEntreprise.raisonSociale : null
    this.agence = rechercheEntreprise ? rechercheEntreprise.agence : null
    this.compte = rechercheEntreprise ? rechercheEntreprise.compte : null
    this.numCarte = rechercheEntreprise ? rechercheEntreprise.numCarte : null
    this.userRestricted = rechercheEntreprise ? rechercheEntreprise.userRestricted : null
    this.restrictedEntrepriseIdList = rechercheEntreprise ? rechercheEntreprise.restrictedEntrepriseIdList : []
  }
}
